import { useEffect, useState } from "react";

/** Matches the breakpoint Sidebar.module.css switches to the mobile menu at. */
const MOBILE_QUERY = "(max-width: 767px)";

function query(): MediaQueryList | null {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return null;
  try {
    return window.matchMedia(MOBILE_QUERY);
  } catch {
    return null;
  }
}

/**
 * True below the mobile breakpoint.
 *
 * The collapsed rail is a desktop affordance: on mobile the sidebar is a
 * full-width menu, so the collapsed state has to be ignored there or the labels
 * would be hidden behind a hamburger that has plenty of room for them.
 */
export function useIsMobileViewport(): boolean {
  const [isMobile, setIsMobile] = useState(() => query()?.matches ?? false);

  useEffect(() => {
    const list = query();
    if (!list) return;

    const onChange = (event: MediaQueryListEvent) => setIsMobile(event.matches);
    setIsMobile(list.matches);

    // Safari < 14 only has the deprecated addListener.
    if (typeof list.addEventListener === "function") {
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    }
    if (typeof list.addListener === "function") {
      list.addListener(onChange);
      return () => list.removeListener(onChange);
    }
    return;
  }, []);

  return isMobile;
}
